import { A3tableType } from '@/types'

// 初始化状态
const initState = {
  // 列表数据
  tableInfo: {
    list: [] as A3tableType[],
    total: 0
  }
}

// 定义 action 类型
type Props = {
  type: 'A3/getList'
  payload: { list: A3tableType[]; total: number }
}

// reducer
export default function Reducer(state = initState, action: Props) {
  switch (action.type) {
    // 获取列表数据
    case 'A3/getList':
      return { ...state, tableInfo: action.payload }

    default:
      return state
  }
}
